import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import '@/lib/sentry';
import { AppRoutes } from '@/routes/app-routes';
import './index.css';

const container = document.getElementById('root')!;
const root = createRoot(container, {
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    // eslint-disable-next-line no-console
    console.warn('Uncaught error:', error, errorInfo.componentStack);
  }),
});

root.render(
  <StrictMode>
    <AppRoutes />
  </StrictMode>,
);
